<mat-card>
    <mat-card-content>
        <mat-card-title>Profile</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>

        <mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="selected.setValue($event)">
            <mat-tab *ngFor="let item of data" [label]="item.label">
                <mat-card *ngFor="let i of item?.profileDisplays">
                    <mat-card-content>
                        <mat-card-title>{{ i.title }}</mat-card-title>
                        <table>
                            <tr *ngFor="let val of i.keyValues">
                                <td class="bold" class="padding-12">{{ val.key }}</td>
                                <td class="bold" class="padding-12">{{ val.value }}</td>
                            </tr>
                        </table>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>